import { motion } from "framer-motion";
import { Mic, ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      id="cta"
      className="relative py-24 md:py-40 bg-[#050505] overflow-hidden"
      data-testid="final-cta"
    >
      <div className="glow-orange" style={{ bottom: "-30%", left: "10%" }} />
      <div className="glow-lime" style={{ top: "-20%", right: "10%" }} />

      <div className="relative max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="border border-white/10 rounded-3xl bg-white/[0.02] backdrop-blur-xl p-10 md:p-20 relative overflow-hidden">
          <p className="font-mono text-[11px] tracking-[0.3em] text-white/40 uppercase mb-8">
            / Vamos a hablar
          </p>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-5xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9]"
          >
            Tu próxima <br />
            venta empieza <br />
            <span className="italic text-white/40">diciendo</span>{" "}
            <span className="text-[#ff5a00]">&ldquo;cobra&rdquo;.</span>
          </motion.h2>

          <div className="mt-14 flex flex-wrap items-center gap-4">
            <a href="/setup" className="btn-primary text-base" data-testid="cta-primary">
              <Mic size={18} strokeWidth={2.5} />
              Crear mi tienda · $20 USD/mes o $25 USD/año
              <ArrowUpRight size={16} />
            </a>
            <a href="#" className="btn-ghost text-base" data-testid="cta-secondary">
              Agendar demo con Chalann
            </a>
          </div>

          <div className="mt-16 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              ["$20 / $25 USD", "Mensual o anual"],
              ["3 min", "Setup por voz o escáner"],
              ["MXN", "Soporte en español"],
              ["IA incluida", "Plan CHALANITO"],
            ].map(([k, v], i) => (
              <div key={i}>
                <p className="font-display text-2xl tracking-tighter">{k}</p>
                <p className="text-white/50 text-xs mt-1 font-mono uppercase tracking-widest">{v}</p>
              </div>
            ))}
          </div>
        </div>

        <footer className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] font-mono text-white/40 tracking-widest">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#ff5a00]" />
            <span>© CHALANN · Hecho con orgullo en México · 2026</span>
          </div>
          <div className="flex gap-6">
            <a href="/legal/privacidad" className="hover:text-white transition-colors" data-testid="footer-privacidad">Privacidad</a>
            <a href="/legal/terminos" className="hover:text-white transition-colors" data-testid="footer-terminos">Términos</a>
            <a href="tel:+523342802102" className="hover:text-white transition-colors" data-testid="footer-contacto">33 4280 2102</a>
          </div>
        </footer>
      </div>
    </section>
  );
}
